import { render, staticRenderFns } from "./ProductCategoryPage.vue?vue&type=template&id=3804fce8&scoped=true"
import script from "./ProductCategoryPage.vue?vue&type=script&lang=js"
export * from "./ProductCategoryPage.vue?vue&type=script&lang=js"
import style0 from "./ProductCategoryPage.vue?vue&type=style&index=0&id=3804fce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3804fce8",
  null
  
)

export default component.exports